<template>
  <section>
    <b-modal
      scrollable
      ref='fispqUploadAndRegisterChemicalAgentsModal'
      id='fispqUploadAndRegisterChemicalAgentsModal'
      header-bg-variant='info'
      header-text-variant='light'
      title='Cadastrar agentes químicos'
      size='xl'
      @show='showModal()'
      @hide='hideModal()'
    >
      <b-overlay
        :show='loading'
        rounded
        opacity='0.6'
        spinner-small
        spinner-variant='primary'
        class='d-inline-block w-100'
        style='min-height: 150px'
      >
        <section class='modal-font-family'>
          <section>
            <p class="mb-1"><strong>Instruções de uso</strong></p>
            <ul class="ml-3">
              <li>
                Anexar a FDS ou FISPQ do produto
              </li>
              <li>
                O sistema irá extrair os dados
              </li>
            </ul>
          </section>

          <section class='mt-3'>
            <input type='file' id='file' @change='onChange' hidden />
            <label class='file-product d-flex align-items-center' for='file'>
              <strong class='ml-3' v-if='file && file.name'>{{ file.name }}</strong>

              <svg v-if='!file.name' class='ml-3 mr-2' width='18' height='18' viewBox='0 0 10 18' fill='none'
                   xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M3.12969 6.00003V12.743C3.13748 13.2361 3.33882 13.7063 3.69026 14.0523C4.0417 14.3982 4.51507 14.5921 5.0082 14.5921C5.50134 14.5921 5.9747 14.3982 6.32615 14.0523C6.67759 13.7063 6.87893 13.2361 6.88672 12.743L6.89281 3.90472C6.89792 3.48328 6.81933 3.06502 6.66159 2.67418C6.50385 2.28334 6.2701 1.9277 5.97389 1.62787C5.67768 1.32804 5.3249 1.09 4.93601 0.927526C4.54711 0.765056 4.12983 0.681396 3.70836 0.681396C3.28689 0.681396 2.86961 0.765056 2.48071 0.927526C2.09182 1.09 1.73904 1.32804 1.44283 1.62787C1.14661 1.9277 0.912864 2.28334 0.755124 2.67418C0.597384 3.06502 0.518793 3.48328 0.523906 3.90472V12.8025C0.51532 13.3959 0.624765 13.985 0.84588 14.5356C1.067 15.0863 1.39537 15.5875 1.81191 16.0101C2.22845 16.4327 2.72484 16.7683 3.27223 16.9973C3.81962 17.2264 4.40709 17.3443 5.00047 17.3443C5.59385 17.3443 6.18132 17.2264 6.72871 16.9973C7.2761 16.7683 7.77249 16.4327 8.18903 16.0101C8.60557 15.5875 8.93394 15.0863 9.15506 14.5356C9.37617 13.985 9.48562 13.3959 9.47703 12.8025V4.48785'
                  stroke='#808080' stroke-miterlimit='10' stroke-linecap='round' />
              </svg>

              <span v-if='!file.name'>Clique aqui para anexar a FDS ou FISPQ do produto</span>
            </label>
          </section>

          <section v-if="chemicalAgents && chemicalAgents.length > 0" class="mt-4">
            <p>
              <strong>
                Os seguintes dados foram extraídos automaticamente via IA do documento {{ file.name }}.
              </strong>
            </p>

            <section>
              <table class="table-form">
                <thead>
                <tr>
                  <th>Agente</th>
                  <th class="px-2">CAS</th>
                </tr>
                </thead>

                <tbody>
                <tr class="py-1" v-for="(item, i) in chemicalAgents" :key="i">
                  <td class="pb-2">
                    <input
                      type="text"
                      disabled
                      :value="item.agentName"
                      :class="item.agentName ? '' : 'error'"
                    />
                  </td>

                  <td class="px-2 pb-2">
                    <input
                      type="text"
                      disabled
                      :value="item.casAgent"
                      :class="item.casAgent ? '' : 'error'"
                    />
                  </td>
                </tr>
                </tbody>
              </table>
            </section>
          </section>
        </section>
        <template v-slot:overlay>
          <div class='text-center loading-spinner'>
            <b-spinner
              style='width: 3rem; height: 3rem'
              variant='primary'
              label='Large Spinner'
            ></b-spinner>
            <h5 class='text-primary'>{{ textLoading }}</h5>
          </div>
        </template>
      </b-overlay>

      <template #modal-footer="{ cancel }">
        <section class='modal-font-family w-100'>
          <section class=''>
            <b-alert show variant='danger' :class='{ hidden: !error }'>
              {{ error }}<br />
            </b-alert>
            <b-alert show variant="success" dismissible :class="{ hidden: !message }">
              {{ message }}
            </b-alert>
          </section>
          <section class='d-flex justify-content-between w-100 '>
            <base-button
              class='w-50 mr-3 btn-cancel'
              @click='cancel()'
            >
              <span>Cancelar</span>
            </base-button>

            <base-button
              class='w-50 btn-add d-flex align-items-center justify-content-center'
              :disabled="!extractedInformationFispqProdutct"
              @click="addChemicalAgents()"
            >
              Cadastrar agentes químicos
            </base-button>
          </section>
        </section>
      </template>
    </b-modal>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import { upload } from '@/utils/upload'
import { extractChemicalAgentsFispqProduct } from '@/services/hoFacilApiChat'

export default {
  name: 'FispqUploadAndRegisterChemicalAgentsModal',
  data() {
    return {
      loading: false,
      textLoading: '',
      file: {},
      extractedInformationFispqProdutct: false,
      chemicalAgents: [],
      extractionAttempts: [],
      logFispqProduct: null,
      extractionStartTime: null,
      handleBeforeUnload: null,
    }
  },
  mounted() {
    this.handleBeforeUnload = () => {
      try {
        const { _id } = this.logFispqProduct
        if (!_id) {
          return
        }
        const sessionId = localStorage.getItem('sessionId')
        const tokenHofacil = localStorage.getItem('tokenHofacil')
        const body = JSON.stringify(
          {
            ...this.logFispqProduct,
            log: 'O usuário atualizou a página ou fechou a janela durante a extração das informações da FISPQ do produto.',
            fispqReadTimeInSeconds: Math.floor((new Date().getTime() - this.extractionStartTime.getTime()) / 1000),
            extractionAttempts: this.extractionAttempts
          })
        fetch(`${process.env.VUE_APP_BASE_URL}/fispq-logs/finish`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            sessionId,
            Authorization: tokenHofacil
          },
          body,
          keepalive: true
        })
      } catch (e) {
      }
    }
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },

  async beforeDestroy() {
    await this.$store.dispatch('access/updateError', '')
    await this.$store.dispatch('access/updateMessage', '')
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
    await this.updateLogFispqProduct('O usuário saiu da página durante o processo de extração das informações da FISPQ do produto!')
  },

  computed: {
    error() {
      return this.$store.getters['access/error']
    },
    message() {
      return this.$store.getters['access/message']
    },
    user() {
      return this.$store.getters['user/current']
    }
  },

  methods: {
    ...mapActions('chemicalAgent', {
      handleProcessChemicalAgentsFispq: 'handleProcessChemicalAgentsFispq'
    }),
    ...mapActions('legalSearch', {
      handleAddBatch: 'handleAddBatch'
    }),
    ...mapActions('userPlans', {
      handleGetAddedAgentsLimitation: 'handleGetAddedAgentsLimitation',
    }),
    ...mapActions('logFispqProduct', {
      handleCreateLogFispqProduct: 'handleCreate',
      handleFinishLogFispqProduct: 'handleFinish'
    }),
    async showModal() {
      await this.$store.dispatch('access/updateError', '')
      await this.$store.dispatch('access/updateMessage', '')
      this.loading = false
      this.extractedInformationFispqProdutct = false
      this.chemicalAgents = []
      this.file = {}
    },
    async hideModal() {
      await this.updateLogFispqProduct('O usuário encerrou o modal durante o processo de extração das informações da FISPQ do produto!')
    },


    async onChange(event) {
      try {
        await this.$store.dispatch('access/updateError', '')
        await this.$store.dispatch('access/updateMessage', '')
        const files = Array.from(event.target.files)
        const [file] = files
        const { name, type } = file || {}
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          this.extractChemicalAgents(reader.result, name, type)
        }
        this.file = file
      } catch (e) {

      }
    },

    async extractChemicalAgents(fileBase64, fileName, type) {
      try {
        this.loading = true
        this.textLoading = 'Extraindo os agentes químicos da FISPQ do produto…'
        await this.$store.dispatch('access/updateError', '')
        await this.$store.dispatch('access/updateMessage', '')
        const body = { fileBase64, fileName, type }
        const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms))

        const maxRetries = 3
        let response = null
        let success = false
        this.extractionAttempts = []
        this.logFispqProduct = null
        this.extractionStartTime = new Date()
        this.extractedInformationFispqProdutct = false
        let filePath = null
        try {
          filePath = await upload(this.file)
        } catch (e) {
        }

        const { username, id: userId } = this.user || {}
        const { data: dataCreateLogFispqProduct } = await this.handleCreateLogFispqProduct({
          userId,
          filePath,
          fileName,
          functionality: 'Extração de agentes químicos da FISPQ do produto cadastro de agentes.',
        })

        const { data } = dataCreateLogFispqProduct || {}
        this.logFispqProduct = data

        try {
          for (let attempt = 1; attempt <= maxRetries; attempt++) {
            try {
              response = await extractChemicalAgentsFispqProduct(body)
              if (!response) {
                await delay(2000)
                continue
              }

              const { data, status } = response || {}
              if (status !== 200) {
                await delay(2000)
                continue
              }

              let product = null

              try {
                const { product: productData, extractionAttempts: extractionAttemptsData } = data || {}
                product = productData
                if (extractionAttemptsData && extractionAttemptsData.length > 0) {
                  this.extractionAttempts.push(...extractionAttemptsData.map((item) => {
                    return {
                      ...item,
                      tentativa: attempt
                    }
                  }))
                }
              } catch {
                await delay(2000)
                continue
              }

              const { agentes: agents } = product || {}
              if (!agents || agents.length <= 0){
                await delay(2000)
                continue
              }

              const { data: dataResponse } = await this.handleProcessChemicalAgentsFispq(
                {
                  agents,
                  userId: this.user.id,
                  planId: this.user.plan && this.user.plan._id ? this.user.plan._id : null
                }
              )
              const { data: chemicalAgents } = dataResponse || {}
              this.chemicalAgents = chemicalAgents || []
              this.loading = false
              success = true
              this.extractedInformationFispqProdutct = true
              break
            } catch (error) {
              if (attempt === maxRetries) {
                break
              }
              await delay(2000)
            }
          }
          if(success){
            await this.updateLogFispqProduct('Extração de agentes químicos da FISPQ do produto realizada com sucesso.')
            return
          }
          await this.updateLogFispqProduct('Não foi possível extrair os agentes químicos da FISPQ do produto.')
          let url = null
          try {
            url = await upload(this.files)
          } catch (e) {
          }
          const { data } = response || {}
          const bodyFispqExtractionErrorEmail = {
            username,
            url,
            functionality: 'Extração de agentes químicos da FISPQ do produto cadastro de agentes.',
            returned: JSON.stringify(data)
          }
          await this.handlesSendFispqExtractionErrorEmail(bodyFispqExtractionErrorEmail)
          await this.$store.dispatch('access/updateError', 'Não foi possível extrair os agentes químicos do arquivo anexado. Verifique o arquivo e tente novamente!')
        } catch (e) {
          await this.$store.dispatch('access/updateError', 'Não foi possível extrair os agentes químicos do arquivo anexado. Verifique o arquivo e tente novamente!')
        } finally {
          this.loading = false
        }
      } catch (e) {
        await this.$store.dispatch('access/updateError', 'Não foi possível extrair os agentes químicos do arquivo anexado. Verifique o arquivo e tente novamente!')
      } finally {
        this.loading = false
      }
    },

    async updateLogFispqProduct(log) {
      try {
        const { _id } = this.logFispqProduct || {}
        if (!_id) {
          return
        }
        await this.handleFinishLogFispqProduct({
          ...this.logFispqProduct,
          log,
          fispqReadTimeInSeconds: Math.floor((new Date().getTime() - this.extractionStartTime.getTime()) / 1000),
          extractionAttempts: this.extractionAttempts
        })
        this.logFispqProduct = null
      } catch (e) {

      }
    },

    async addChemicalAgents() {
      try {
        await this.$store.dispatch('access/updateError', '')
        await this.$store.dispatch('access/updateMessage', '')
        this.loading = true
        this.textLoading = 'Cadastrando agentes químicos...'
        const { data, status } = await this.handleAddBatch({ chemicalAgents: this.chemicalAgents })


        if (status !== 201) {
          const { errors } = data || {}

          this.$bvToast.toast(errors, {
            title: 'Atenção',
            variant: 'danger',
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000
          })
          this.loading = false
          return
        }
        const { message } = data || {}
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: 'success',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })

        this.textLoading = 'Carregando agentes...'
        await this.$store.dispatch('legalSearch/load', this.user.id)
        await this.handleGetAddedAgentsLimitation(this.user)
        this.$bvModal.hide('fispqUploadAndRegisterChemicalAgentsModal')
        this.loading = false
      } catch (e) {
        this.loading = false
        this.$bvToast.toast('Ocorreu um erro ao cadastrar agentes químicos. Verifique as informações tente novamente!', {
          title: 'Atenção',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.file-uploaded {
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  color: var(--navy-blue);
  border: 1px solid var(--navy-blue);

  padding: 6px 12px;

  border-radius: 4px;

  transition: all 0.2s ease-in-out;

  text-decoration: none;

  cursor: pointer;
}

.file-product {
  border-radius: 6.25px;
  border: 1px dashed #808080;
  width: 100%;
  height: 40px;
  cursor: pointer;

  span {
    color: #808080;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
  }
}

.btn-cancel {
  background: transparent !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.btn-add {
  background: var(--navy-blue) !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: #FFFFFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.table-form {
  width: 100%;
  border-collapse: separate;
}

.table-form th {
  text-align: left;
  font-weight: 600;
  font-size: 16px;
  color: #222;
  padding-bottom: 4px;
}

.table-form td {
  vertical-align: top;
}

.table-form input {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #808080;
  color: #262626;
  outline: none;
}

.table-form input:focus {
  border-color: #5b9cff;
}

.table-form input.error {
  border: 1px solid #ff3b30;
}

</style>
